module.exports = __webpack_public_path__ + "static/img/gws_gayathri.4d420bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gws_gayathri.jpg
// module id = 3qtQ
// module chunks = 1